export interface ThreadScrollMetrics {
    scrollTop: number
    scrollHeight: number
    clientHeight: number
}

export function readThreadScrollMetrics(element: HTMLElement): ThreadScrollMetrics {
    return {
        scrollTop: element.scrollTop,
        scrollHeight: element.scrollHeight,
        clientHeight: element.clientHeight,
    }
}

/**
 * Return scroll movement only when the scrollable layout itself stayed fixed.
 * Virtualizer measurement and prepend compensation can move scrollTop while
 * scrollHeight changes; those movements are not user navigation.
 */
export function stableThreadScrollDelta(previous: ThreadScrollMetrics | null, next: ThreadScrollMetrics): number | null {
    if (!previous || previous.scrollHeight !== next.scrollHeight || previous.clientHeight !== next.clientHeight) return null
    return next.scrollTop - previous.scrollTop
}
